import { ReactionName } from '@lopo-tech/lopo-api'
import { textResources } from 'src/lang/de'

// The English catalogue in @lopo-tech/frontends-shared carries no thumbs strings, so the union
// getTranslations() returns does not expose them. Reading them optionally keeps the German names
// without waiting for a package release.
type ThumbsTexts = {
  thumbs_up?: string;
  thumbs_down?: string;
}

export const translateReactions = (name: ReactionName): string => {
  const { haha, interesting, like, ohNo, wow, condolences } = textResources.reactions
  const {
    thumbs_up: thumbsUp, thumbs_down: thumbsDown
  } = textResources.reactions as ThumbsTexts
  switch (name) {
    case 'HAHA':
      return haha
    case 'OH_NO':
      return ohNo
    case 'OLD_HEART':
      return like
    case 'LIKE':
      return like
    case 'INTERESTING':
      return interesting
    case 'WOW':
      return wow
    case 'CANDLE':
      return condolences
    case 'THUMBS_UP':
      return thumbsUp ?? ''
    case 'THUMBS_DOWN':
      return thumbsDown ?? ''
    default:
      return ''
  }
}
